import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane, faExclamationTriangle, faCheckCircle } from '@fortawesome/free-solid-svg-icons';

import { AlertData } from './AdminNotifications.types';

// スタイル定義
export const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
`;

export const Title = styled.h1`
  font-size: 1.5rem;
  margin-bottom: 20px;
  color: #333;
  border-bottom: 2px solid #eee;
  padding-bottom: 10px;
`;

export const FormGroup = styled.div`
  margin-bottom: 20px;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-weight: bold;
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 150px;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  resize: vertical;
  &:focus {
    outline: none;
    border-color: #4f9fd1;
    box-shadow: 0 0 0 2px rgba(79, 159, 209, 0.2);
  }
`;

export const Button = styled.button`
  background-color: #4f9fd1;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #3d8cbf;
  }
  
  &:disabled {
    background-color: #aaa;
    cursor: not-allowed;
  }
  
  svg {
    margin-right: 8px;
  }
`;

export const AlertBox = styled.div<{ $type: 'success' | 'error' | 'warning' }>`
  padding: 15px;
  margin: 20px 0;
  border-radius: 4px;
  display: flex;
  align-items: center;
  
  background-color: ${props => 
    props.$type === 'success' ? '#d4edda' : 
    props.$type === 'error' ? '#f8d7da' : '#fff3cd'};
  
  color: ${props => 
    props.$type === 'success' ? '#155724' : 
    props.$type === 'error' ? '#721c24' : '#856404'};
  
  svg {
    margin-right: 10px;
    font-size: 1.2rem;
  }
`;

export const CharCounter = styled.div<{ $isOver: boolean }>`
  text-align: right;
  margin-top: 5px;
  font-size: 0.8rem;
  color: ${props => props.$isOver ? '#dc3545' : '#6c757d'};
`;

// アラートメッセージコンポーネント
interface AlertMessageProps {
  alert: AlertData | null;
}

export const AlertMessage: React.FC<AlertMessageProps> = ({ alert }) => {
  if (!alert) return null;
  
  return (
    <AlertBox $type={alert.type} data-testid="alert-message">
      <FontAwesomeIcon 
        icon={alert.type === 'success' ? faCheckCircle : faExclamationTriangle} 
      />
      {alert.message}
    </AlertBox>
  );
}; 